import type { Dispatch } from 'react'

import type { PageLogger } from '../../../../../bi/mfi'
import type { Option } from '../../Content'
import type { Action } from '../index'

type ToggleAppParams = {
  dispatch: Dispatch<Action>
  option: Option
  index: number
  checked: boolean
  pageLogger: PageLogger
  questionKey: string
}

export const toggleApp = (params: ToggleAppParams) => {
  const { dispatch, option, index, checked, pageLogger, questionKey } = params
  const { optionKey, level } = option

  if (level === 'built-in') {
    // Do nothing on built-in or for weird apps
    return
  }

  if (!checked) {
    void pageLogger.clickAnswer({ questionKey, buttonName: optionKey, position: index + 1 })
  }

  dispatch({ type: 'toggleApp', optionKey })
}
